/**
 * Helper function to find language toggle in content array
 * @param {Array|Object} details - Can be either an array directly or an object with a content property
 * @returns {Object|null} - The language toggle object if found, null otherwise
 */
export const getLanguageToggle = details => {
  if (!details) return null

  // Helper to check if content item is a language toggle
  const isLanguageToggle = content => {
    const normalizedContentTypeId =
      typeof content?.contentType === 'string'
        ? content.contentType.toLowerCase()
        : String(content?.contentType?.id || '').toLowerCase()
    const normalizedType = String(content?.type || '').toLowerCase()

    return (
      content?.__typename === 'Lang' ||
      normalizedContentTypeId === 'lang' ||
      normalizedType === 'lang'
    )
  }

  // If details is an array, search directly
  if (Array.isArray(details)) {
    return details.find(isLanguageToggle)
  }

  // If details has a content property, search in that
  if (details.content && Array.isArray(details.content)) {
    return details.content.find(isLanguageToggle)
  }

  return null
}
